module.exports = __webpack_public_path__ + "static/img/6.d79f40b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/6.jpg
// module id = wp/8
// module chunks = 1